import { render, staticRenderFns } from "./PersonDataDigital.vue?vue&type=template&id=96bd7256&"
import script from "./PersonDataDigital.vue?vue&type=script&lang=js&"
export * from "./PersonDataDigital.vue?vue&type=script&lang=js&"
import style0 from "./PersonDataDigital.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports